(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  const TRAIL_LENGTH = 28;

  // ── Disco ball cursor ────────────────────────────────────────────────────────
  function makeDiscoBallCursor(frame) {
    const canvas = document.createElement('canvas');
    canvas.width = 28; canvas.height = 28;
    const x = canvas.getContext('2d');
    const cx = 14, cy = 14, r = 11;

    // Outer glow halo
    const glow = x.createRadialGradient(cx, cy, r * 0.6, cx, cy, r * 1.4);
    glow.addColorStop(0, 'rgba(220,220,255,0.35)');
    glow.addColorStop(1, 'rgba(220,220,255,0)');
    x.beginPath();
    x.arc(cx, cy, r * 1.4, 0, Math.PI * 2);
    x.fillStyle = glow;
    x.fill();

    // Dark sphere base
    const sphere = x.createRadialGradient(cx - r * 0.3, cy - r * 0.3, 0, cx, cy, r);
    sphere.addColorStop(0, '#777');
    sphere.addColorStop(0.45, '#333');
    sphere.addColorStop(1, '#0a0a0a');
    x.beginPath();
    x.arc(cx, cy, r, 0, Math.PI * 2);
    x.fillStyle = sphere;
    x.fill();

    // Mirror tiles — greyscale, shimmer driven by frame
    const tile = 3;
    x.save();
    x.beginPath();
    x.arc(cx, cy, r - 0.5, 0, Math.PI * 2);
    x.clip();
    for (let ty = 1; ty < 28; ty += tile) {
      for (let tx = 1; tx < 28; tx += tile) {
        const dx = tx + tile / 2 - cx;
        const dy = ty + tile / 2 - cy;
        if (dx * dx + dy * dy < (r - 1) * (r - 1)) {
          // Shimmer: each tile's brightness pulses at its own phase
          const phase = (tx * 1.3 + ty * 0.9 + frame * 0.4) % (Math.PI * 2);
          const bright = 38 + 52 * Math.pow(Math.max(0, Math.cos(phase)), 2);
          x.fillStyle = `hsl(0,0%,${bright}%)`;
          x.fillRect(tx, ty, tile - 1, tile - 1);
        }
      }
    }
    x.restore();

    // Specular highlight
    const hi = x.createRadialGradient(cx - r * 0.3, cy - r * 0.36, 0, cx - r * 0.18, cy - r * 0.22, r * 0.42);
    hi.addColorStop(0, 'rgba(255,255,255,0.95)');
    hi.addColorStop(1, 'rgba(255,255,255,0)');
    x.beginPath();
    x.arc(cx, cy, r, 0, Math.PI * 2);
    x.fillStyle = hi;
    x.fill();

    return canvas.toDataURL();
  }

  let cursorFrame = 0;
  function animateCursor() {
    cursorFrame++;
    document.documentElement.style.setProperty(
      '--disco-cursor',
      `url(${makeDiscoBallCursor(cursorFrame)}) 14 14, auto`
    );
    setTimeout(animateCursor, 70);
  }
  animateCursor();

  const cursorStyle = document.createElement('style');
  cursorStyle.textContent = '* { cursor: var(--disco-cursor, auto) !important; }';
  document.head.appendChild(cursorStyle);

  // ── Canvas overlay ───────────────────────────────────────────────────────────
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  Object.assign(canvas.style, {
    position: 'fixed', top: '0', left: '0',
    width: '100%', height: '100%',
    pointerEvents: 'none', zIndex: '999999',
  });
  document.body.appendChild(canvas);

  function resize() { canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
  resize();
  window.addEventListener('resize', resize);

  const points = [];
  const beams  = [];
  let hueOffset = 0;

  window.addEventListener('mousemove', (e) => {
    points.unshift({ x: e.clientX, y: e.clientY });
    if (points.length > TRAIL_LENGTH) points.length = TRAIL_LENGTH;
  });

  window.addEventListener('click', (e) => {
    const baseHue = Math.random() * 360;
    // 24 evenly-spaced primary beams
    for (let i = 0; i < 24; i++) {
      const angle = (i / 24) * Math.PI * 2;
      beams.push({
        x: e.clientX, y: e.clientY,
        angle,
        hue: (baseHue + (i / 24) * 360) % 360,
        length: 0,
        maxLength: 80 + Math.random() * 60,
        speed: 9 + Math.random() * 6,
        width: 0.7 + Math.random() * 0.5,
        alpha: 1,
        phase: 'grow',
      });
    }
    // 16 random scatter beams
    for (let i = 0; i < 16; i++) {
      beams.push({
        x: e.clientX, y: e.clientY,
        angle: Math.random() * Math.PI * 2,
        hue: (baseHue + Math.random() * 200) % 360,
        length: 0,
        maxLength: 40 + Math.random() * 50,
        speed: 7 + Math.random() * 5,
        width: 0.35 + Math.random() * 0.35,
        alpha: 0.9,
        phase: 'grow',
      });
    }
  });

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    hueOffset = (hueOffset + 1.2) % 360;

    // Comet trail
    for (let i = 0; i < points.length; i++) {
      const t = 1 - i / TRAIL_LENGTH;
      const radius = 10 * t;
      const alpha  = t * t;
      const hue    = (hueOffset + i * (360 / TRAIL_LENGTH)) % 360;

      ctx.beginPath();
      ctx.arc(points[i].x, points[i].y, radius * 2.2, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${hue},100%,65%,${alpha * 0.25})`;
      ctx.fill();

      ctx.beginPath();
      ctx.arc(points[i].x, points[i].y, radius, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${hue},100%,70%,${alpha})`;
      ctx.fill();
    }

    // Light beams
    for (let i = beams.length - 1; i >= 0; i--) {
      const b    = beams[i];
      const endX = b.x + Math.cos(b.angle) * b.length;
      const endY = b.y + Math.sin(b.angle) * b.length;
      const hue2 = (b.hue + 40) % 360;

      // Glow pass
      const glow = ctx.createLinearGradient(b.x, b.y, endX, endY);
      glow.addColorStop(0, `hsla(${b.hue},100%,70%,${b.alpha * 0.2})`);
      glow.addColorStop(1, `hsla(${hue2},100%,70%,0)`);
      ctx.beginPath();
      ctx.moveTo(b.x, b.y);
      ctx.lineTo(endX, endY);
      ctx.lineWidth  = b.width * 5;
      ctx.strokeStyle = glow;
      ctx.lineCap    = 'butt';
      ctx.stroke();

      // Core beam
      const core = ctx.createLinearGradient(b.x, b.y, endX, endY);
      core.addColorStop(0, `hsla(${b.hue},100%,96%,${b.alpha})`);
      core.addColorStop(1, `hsla(${hue2},100%,78%,0)`);
      ctx.beginPath();
      ctx.moveTo(b.x, b.y);
      ctx.lineTo(endX, endY);
      ctx.lineWidth  = b.width;
      ctx.strokeStyle = core;
      ctx.stroke();

      // Update
      if (b.phase === 'grow') {
        b.length += b.speed;
        if (b.length >= b.maxLength) {
          b.length = b.maxLength;
          b.phase  = 'fade';
        }
      } else {
        b.alpha -= 0.055;
        if (b.alpha <= 0) { beams.splice(i, 1); continue; }
      }

      b.hue = (b.hue + 1.2) % 360;
    }

    requestAnimationFrame(draw);
  }

  requestAnimationFrame(draw);
})();
